import { Vendor } from '../vendor/vendor.model';
import { Location } from '../location/location.model';
import { PurchaseOrderLineItem, PurchaseOrderLineItemMiscellaneous } from './purchase-order-line-item.model';
import { Utils } from '../utils.service';
import { PurchaseOrderTransactionPartType } from './purchase-order-transaction';
import { SignaturePageType } from 'src/app/core-ui/purchase-order/purchase-order-pdf/purchase-order-pdf.component';
import { PurchaseOrderAdditionalData } from './models/additional-data.model';
import { UiUtils } from 'src/app/shared-ui/utils/ui-utils';

export enum PurchaseOrderPaymentType
{
    None = 0,
    Cash = 1,
    Check = 2,
    WireTransfer = 4
}

export class PurchaseOrder
{
    public dataCompletnessErrors: string[];
    public latitude: number;
    public longitude: number;
    public totalAdjustment: number;
    public nonFerrousAdjustment: number;
    public catsAdjustment: number;
    public id: number;
    public number: string;
    public vendorId: number;
    public vendorName: string;
    public vendor: Vendor;
    public buyerName: string;
    public buyerFirstName: string;
    public buyerLastName: string;
    public imageUrls: string[];
    public locationId: number;
    public location: Location;
    public lineItemsAllConverters: PurchaseOrderLineItem[] = [];
    public lineItemsConverter: PurchaseOrderLineItem[] = [];
    public lineItemsNoNumber: PurchaseOrderLineItem[] = [];
    public lineItemsCustom: PurchaseOrderLineItem[] = [];
    public lineItemsCategory: PurchaseOrderLineItem[] = [];
    public lineItemsMiscellaneous: PurchaseOrderLineItemMiscellaneous[] = [];
    public purchaseDate: Date; // This is in LOCATION timezone
    public exportedDate: Date; // This is in LOCATION timezone
    public signaturePageUrl: any;
    public signaturePageType?: SignaturePageType;
    public extraPagesUrl: any;
    public newVersion: boolean;
    public totalPrice: number;
    public totalAdjusted: number;
    public numConverters: number;
    public numCustom: number;
    public numNoNumber: number;
    public numCategory: number;
    public print: string;
    public numMiscellaneous: number;
    public isLocked: boolean;
    public isInventoryList: boolean;
    public isShared: boolean;
    public hasBeenLocked: boolean;
    public paymentType: number;
    public currency: string;
    public notes: string;
    public totalCash: number;
    public totalCheck: number;
    public totalWire: number;
    public checkNumber: string;
    public purchaseTime: string;
    public timeZone: string;
    public contactId: number;
    public contactLicenseNumber: string;
    public contactState: string;
    public placeOfSale: number;
    public placeOfSaleLocationAddress: string;
    public placeOfSaleLocationCity: string;
    public placeOfSaleLocationState: string;
    public placeOfSaleLocationZip: string;
    public middleInitial: string;
    public californiaIdNumber: string;
    public hasCompleteData: boolean;

    public vehicleMake: string;
    public vehicleModel: string;
    public vehicleColor: string;
    public vehicleNumber: string;
    public vehicleState: string;

    public batchNumber: string;
    public batchId: number;
    public additionalData: PurchaseOrderAdditionalData;

    public hedgeId: number | null;
    public hedgeContractNumber: string | null;

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
            if (json.vendor != null)
            {
                this.vendor = new Vendor(json.vendor);
                this.vendorName = this.vendor.name;
            }
            // if(json.print == undefined) 
            //     this.print = '';
            // if(json.middleInitial == undefined)
            //     this.middleInitial = '';
            // if(json.californiaIdNumber)
            //     this.californiaIdNumber = '';
            // if(json.vehicleMake)
            //     this.vehicleMake = ''
            // if(json.vehicleModel)
            //     this.vehicleModel = ''
            // if(json.vehicleColor)
            //     this.vehicleColor = ''
            // if(json.vehicleNumber)
            //     this.vehicleNumber = ''
            // if(json.vehicleState)
            //     this.vehicleState = ''
            if (json.location) this.location = new Location(json.location);
            if (json.purchaseDate != null) this.purchaseDate = Utils.convertApiDateStringToDate(json.purchaseDate);
            if (json.exportedDate != null) this.exportedDate = Utils.convertApiDateStringToDate(json.exportedDate);
            if (json.lineItemsConverter) this.lineItemsConverter =
                json.lineItemsConverter.map(item => new PurchaseOrderLineItem(item, PurchaseOrderTransactionPartType.Converter))
                    .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
            if (json.lineItemsCustom) this.lineItemsCustom =
                json.lineItemsCustom.map(item => new PurchaseOrderLineItem(item, PurchaseOrderTransactionPartType.Custom))
                    .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
            if (json.lineItemsNoNumber) this.lineItemsNoNumber =
                json.lineItemsNoNumber.map(item => new PurchaseOrderLineItem(item, PurchaseOrderTransactionPartType.NoNumber))
                    .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
            if (json.lineItemsCategory) this.lineItemsCategory =
                json.lineItemsCategory.map(item => new PurchaseOrderLineItem(item, PurchaseOrderTransactionPartType.Category))
                    .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
            if (json.lineItemsMiscellaneous)
                this.lineItemsMiscellaneous = json.lineItemsMiscellaneous.map(item => new PurchaseOrderLineItemMiscellaneous(item))
                    .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
            this.lineItemsAllConverters = this.lineItemsConverter
                .concat(this.lineItemsCustom, this.lineItemsNoNumber, this.lineItemsCategory)
                .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
            if (this.buyerName == null) this.buyerName = `${this.buyerFirstName} ${this.buyerLastName}`;
            if (this.imageUrls == null) this.imageUrls = [];
            if(this.additionalData == null)
                this.additionalData = {} as PurchaseOrderAdditionalData;
            this.currency = json.currency;
            if(this.nonFerrousAdjustment == null)
                this.nonFerrousAdjustment = 0
            if(this.catsAdjustment == null)
                this.catsAdjustment = 0
            this.totalAdjustment = this.nonFerrousAdjustment + this.catsAdjustment;
            this.totalAdjusted = Math.round((this.totalPrice + this.nonFerrousAdjustment + this.catsAdjustment) * 100) / 100
        }
    }

    get completnessMessage(): string[] {
        return this.dataCompletnessErrors.map(x => UiUtils.errorsDict[x]);
    }
    get geolocationAvailable(): boolean {
        return this.latitude != null && this.longitude != null
    }
    get totalNumConverters(): number { return this.numConverters + this.numCustom + this.numNoNumber + this.numCategory; }
    get totalConvertersPrice(): number {
        return Utils.sum(this.lineItemsConverter, 'totalPrice') +
            Utils.sum(this.lineItemsCustom, 'totalPrice') +
            Utils.sum(this.lineItemsNoNumber, 'totalPrice') +
            Utils.sum(this.lineItemsCategory, 'totalPrice');
    }
    get totalMiscPrice(): number {
        return Utils.sum(this.lineItemsMiscellaneous, 'totalPrice');
    }
    get totalsValid() {
        return Math.round((this.totalCash + this.totalCheck + this.totalWire) * 100) / 100
            == Math.round((this.totalPrice + this.catsAdjustment + this.nonFerrousAdjustment) * 100) / 100
    }
    get vehicleInfoValid(): boolean {
        return this.vehicleMake?.length > 0 
            && this.vehicleModel?.length > 0
            && this.vehicleColor?.length > 0
            && this.vehicleNumber?.length > 0
            && this.vehicleState?.length > 0;
    }
    get numberStateValid(): boolean {
        return this.vehicleNumber?.length > 0
            && this.vehicleState?.length > 0;
    }
    
    get adjustment(){
        if(this.lineItemsMiscellaneous.length == 0)
            return 0;

        return Math.ceil(this.totalMiscPrice) - this.totalMiscPrice;
    }

    get adjustedTotal() {
        return Math.ceil(this.totalConvertersPrice + this.totalMiscPrice);
    }

    updateQuantitiesAndPrices(): void
    {
        this.numConverters = this.lineItemsConverter.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
        this.numNoNumber = this.lineItemsNoNumber.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
        this.numCategory = this.lineItemsCategory.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
        this.numCustom = this.lineItemsCustom.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
        this.numMiscellaneous = this.lineItemsMiscellaneous.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
        this.lineItemsAllConverters = this.lineItemsConverter.concat(this.lineItemsCustom, this.lineItemsNoNumber, this.lineItemsCategory)
            .sort((a, b) => b.lastUpdated.getTime() - a.lastUpdated.getTime());
        this.updateTotalPrice();
    }

    private updateTotalPrice(): number
    {
        this.totalPrice = 0;
        this.lineItemsConverter.forEach(item => this.totalPrice += item.totalPrice);
        this.lineItemsCustom.forEach(item => this.totalPrice += item.totalPrice);
        this.lineItemsNoNumber.forEach(item => this.totalPrice += item.totalPrice);
        this.lineItemsCategory.forEach(item => this.totalPrice += item.totalPrice);
        this.lineItemsMiscellaneous.forEach(item => this.totalPrice += item.totalPrice);

        return this.totalPrice;
    }
}
